import { CouponSelectedProp } from '@components/molecules/CouponSelector'
import { Separator } from '@components/ui/separator'
import { FC } from 'react'

interface PriceBoxProps {
    totalPriceHeading: string
    totalPrice: number
    totalDiscountHeading: string
    totalDiscount: number
    couponSelected?: CouponSelectedProp
    totalAmount: number
    hideBorder?: boolean
}

const PriceBox: FC<PriceBoxProps> = ({ totalPriceHeading, totalPrice, totalDiscountHeading, totalDiscount, couponSelected, totalAmount, hideBorder = false }) => {
  return (
      <div className={`${hideBorder ? '' : 'border'} p-4 rounded-sm flex flex-col gap-4`}>
          <div className={` title_medium self-start md:title_large mt-4`}>Price Details</div>
          <div className=" flex flex-col gap-3">
              <div className=" w-full flex justify-between list_medium text-neutral-750">
                  <div>{totalPriceHeading}</div>
                  <div>₹{totalPrice.toLocaleString()}</div>
              </div>
              <div className=" w-full flex justify-between list_medium text-neutral-750">
                  <div>{totalDiscountHeading}</div>
                  <div className=" text-green-500">
                      {totalDiscount === 0 ? 'not applied' : `-₹${totalDiscount}`}
                  </div>
              </div>
              <div className=" w-full flex justify-between list_medium text-neutral-750">
                  <div>
                      Convenience fee
                      {/* <span className=" text-primary-500">Know more</span>{' '} */}
                  </div>
                  <div className=" text-green-500">free</div>
              </div>
              <div className=" w-full flex justify-between list_medium text-neutral-750">
                  <div>Delivery Charges</div>
                  {/* <div>
                                {deliveryPrice ? `₹${Math.round(deliveryPrice)}` : 'calculating'}
                              </div> */}
                  <div>
                      <div className=" text-green-500">free</div>
                  </div>
              </div>
              {couponSelected ? (
                  <div className=" w-full flex justify-between list_medium text-neutral-750">
                      <div>
                          Coupon applied -{' '}
                          <span className="text-primary-500">{couponSelected.code}</span>
                      </div>
                      {/* <div>
                                {deliveryPrice ? `₹${Math.round(deliveryPrice)}` : 'calculating'}
                              </div> */}
                      <div>
                          <div className=" text-green-500">
                              -₹{couponSelected.discountAmount}
                          </div>
                      </div>
                  </div>
              ) : undefined}
          </div>
          <Separator />
          <div className=" w-full flex justify-between list_medium text-neutral-750">
              <div className=" title_medium font-black">Total Amount</div>
              <div>{totalAmount ? `₹${totalAmount}` : '...'}</div>
          </div>
      </div>
  )
}

export default PriceBox